<ng-container *ngIf="isTemplate; else string">
  <ng-container *ngIf="templateIsEmpty === false; else noData">
    <ng-container *ngTemplateOutlet="inputTemplate ?? null"></ng-container>
  </ng-container>
</ng-container>

<ng-template #string>
  <ng-container *ngIf="stringValue; else noData">
    {{ stringValue }}
  </ng-container>
</ng-template>

<ng-template #noData>
  <span>
    <i class="grey" nz-icon nzType="inbox" nzTheme="outline"></i>
    <span class="grey no-data-text">{{ emptyText }}</span>
  </span>
</ng-template>
